<template>
	<div class="container">
		<div class="page-header">
			<h2 class="h2">Definições de localidade</h2>
			<router-link to="/dashboard" class="btn btn-secondary">Voltar</router-link>
		</div>

		<div class="card">
			<form @submit.prevent="salvarLocal" class="candidate-form">
				<div class="form-row">
					<div class="form-group">
						<label for="local">Local</label>
						<input type="text" id="local" v-model="formData.local" required placeholder="Local" />
					</div>
				</div>

				<div class="form-row">
					<div class="form-group">
						<label for="estado">Estado</label>
						<select name="estado" id="estado" v-model="formData.estado">
							<option value="São Paulo">SP</option>
							<option value="Rio de Janeiro">RJ</option>
						</select>
					</div>
				</div>

				<div class="form-row">
					<div class="form-group">
						<label for="cidade">Cidade</label>
						<select name="estado" id="estado" v-model="formData.cidade">
							<option value="São Paulo">São Paulo</option>
							<option value="Rio de Janeiro">Rio de Janeiro</option>
							<option value="Interior">Interior</option>
						</select>
					</div>
				</div>

				<div class="error" v-if="error">{{ error }}</div>

				<div class="form-actions">
					<button type="submit" class="btn btn-primary" :disabled="loading">
						{{ "Salvar" }}
					</button>
					<button type="submit" class="btn btn-secondary" @click="limparLocal">
						{{ "Limpar" }}
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const formData = reactive({
	local: "",
	estado: "",
	cidade: "",
});
const loading = ref(false);
const error = ref(false);

const limparLocal = () => {
	Object.assign(formData, {
		local: "",
		estado: "",
		cidade: "",
	});
	localStorage.removeItem("local");
};

function salvarLocal() {
	if (formData.estado.value == "" || formData.cidade.value == "") {
		error.value = 'Você precisa informar Estado ou Cidade';
		return
	}
	localStorage.setItem("local", JSON.stringify(formData));
	router.push("/dashboard");
}

onMounted(() => {
	const savedLocal = JSON.parse(localStorage.getItem("local"));

	if (savedLocal) {
		formData.local = savedLocal.local;
		formData.estado = savedLocal.estado;
		formData.cidade = savedLocal.cidade;
	}
})

</script>

<style scoped>
.page-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 2rem;
}

.candidate-form {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.form-row {
	max-width: 600px;
	width: 100%;
}

.form-actions {
	display: flex;
	gap: 1rem;
	margin-top: 2rem;
}

@media (max-width: 768px) {
	.page-header {
		flex-direction: column;
		gap: 1rem;
	}

	.form-row {
		grid-template-columns: 1fr;
		gap: 0;
	}

	.form-actions {
		flex-direction: column;
	}
}
</style>
